export class Util {
  public static resizeCanvas(canvas, width, height, rate) {
    canvas.width = width * rate
    canvas.height = height * rate
    canvas.style.width = width + 'px'
    canvas.style.height = height + 'px'
    let g = canvas.getContext('2d')
    g.setTransform(rate, 0, 0, rate, 0, 0)
  }
  public static createCanvas(width: number, height: number): HTMLCanvasElement {
    let canvas = document.createElement('canvas')
    canvas.width = width * 2
    canvas.height = height * 2
    canvas.getContext('2d').setTransform(2, 0, 0, 2, 0, 0)
    canvas.style.width = width + 'px'
    canvas.style.height = height + 'px'
    return canvas
  }
  public static throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    let last,
        deferTimer;
    return function () {
      let context = scope || this;
  
      let now = +new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }
}
